import { z } from '@harvestiq/zod';
import { dbClaimSchema } from './db-claims';
import { dbClaimEventSchema } from '../claim-events/db-claim-events';
import { coverageSchema } from '../coverages/coverage';
import { dbClaimDocumentSchema } from '../claim-documents/db-claim-documents';
import { safeDbUserSchema } from '../users/db-user';

export const claimSchema = dbClaimSchema.extend({
  endorsement: coverageSchema,
  claimEvents: z.array(dbClaimEventSchema),
  claimDocuments: dbClaimDocumentSchema
    .extend({
      // Add the user who uploaded the document (if any)
      uploadedByUser: safeDbUserSchema.nullable(),
    })
    .array(),
});

export type Claim = z.infer<typeof claimSchema>;
